import React from 'react';
import {
  ImmutableMap,
  InstrumentItem
} from '@biorad-lsg-tsc/instrument-family-plugin/lib/components/InstrumentRow/InstrumenItem';
import { Seq } from 'immutable';
import { LoadableTBodyList } from '../../../frontend-common-libs/src/components/common/tables/Types';
import InstrumentFleetRow from '../instrument-fleet-row/InstrumentFleetRow';

export enum InstrumentTypeEnum {
  ptcTempo = 'PTCTempo'
}

export default function renderInstrumentList(
  ptcTempoInstruments: Seq.Indexed<ImmutableMap<InstrumentItem>>,
  selectedFleetToggle: string,
  selectAllCheckbox: boolean,
  updateSelectedInstruments: (id: string, select: boolean) => void,
  updateReservedInstruments: (id: string, reserved: boolean) => void,
  reservationProtocol: string,
  setReservationProtocol: React.Dispatch<React.SetStateAction<string>>
): LoadableTBodyList {
  return ptcTempoInstruments.map((instrumentObj: ImmutableMap<InstrumentItem>) => {
    const instrumentId = instrumentObj.get('id');
    return (
      <InstrumentFleetRow
        key={instrumentId}
        instrument={instrumentObj}
        fleetToggleOption={selectedFleetToggle}
        selectAllCheckbox={selectAllCheckbox}
        updateSelectedInstruments={updateSelectedInstruments}
        updateReservedInstruments={updateReservedInstruments}
        reservationProtocol={reservationProtocol}
        setReservationProtocol={setReservationProtocol}
      />
    );
  });
}
